import { create } from 'zustand'

import { UUID } from '@/types/Id'

interface OrganizationStore {
  activeOrgId: UUID | ''
  setActiveOrgId: (id: UUID | '') => void
}

export const useOrganizationStore = create<OrganizationStore>((set, get) => ({
  activeOrgId: '' as const,
  setActiveOrgId: (id: UUID | '') => {
    if (get().activeOrgId === id) {
      return
    }

    set({ activeOrgId: id })
  },
}))
